import React, { useEffect } from 'react';
import { Form, Input, Button, Select, InputNumber, message } from 'antd';

const layout = {
	labelCol: {
		span: 8,
	},
	wrapperCol: {
		span: 18,
	},
};
const tailLayout = {
	wrapperCol: {
		offset: 8,
		span: 16,
	},
};

const EditModelForm = ({ makes, model, setEditModal, setRefresh, updateModel }) => {
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue(model);
	}, [form, model]);

	const onFinish = async (values) => {
		const data = {
			make: values.make,
			name: values.model,
			yearStart: values.yearStart,
		};
		await updateModel(model._id, data);
		setEditModal();
		setRefresh();
	};

	const onFinishFailed = (errorInfo) => {
		message.error('Something went wrong!');
	};

	return (
		<div>
			<Form
				{...layout}
				name="basic"
				initialValues={{ remember: true }}
				form={form}
				onFinish={onFinish}
				onFinishFailed={onFinishFailed}
			>
				<Form.Item
					label="Make"
					name="make"
					rules={[{ required: true, message: 'Please select make!' }]}
					initialValue={model?.make}
				>
					<Select showSearch placeholder="Select a make">
						{makes.map((make) => (
							<Select.Option value={make._id} key={make._id}>
								{make._id}
							</Select.Option>
						))}
					</Select>
				</Form.Item>
				<Form.Item
					label="Model"
					name="model"
					rules={[{ required: true, message: 'Please input model!' }]}
					initialValue={model?.name}
				>
					<Input />
				</Form.Item>
				<Form.Item
					label="Starting Year"
					name="yearStart"
					rules={[{ required: true, message: 'Please input year!' }]}
					initialValue={model?.yearStart}
				>
					<InputNumber />
				</Form.Item>
				<Form.Item label="Ending Year" name="yearEnd" initialValue={model?.yearEnd}>
					<InputNumber />
				</Form.Item>
				<Form.Item {...tailLayout}>
					<Button type="primary" htmlType="submit">
						Update Model
					</Button>
				</Form.Item>
			</Form>
		</div>
	);
};

export default EditModelForm;
